import { createFileRoute, notFound } from "@tanstack/react-router";

import { usersQueries } from "@/api/resources/users/queries";
import { workspaceInvitationsQueries } from "@/api/resources/workspaceInvitations/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import WorkspaceUsersPage from "@/components/Workspace/WorkspaceUsersPage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/settings/users/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.workspace-users"),
        icon: <Icon.USERS />,
        path: "/workspaces/$workspace_id/settings/users",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();

    await Promise.all([
      context.queryClient.ensureQueryData(usersQueries.listWorkspaceUsers(workspace_id)),
      context.queryClient.ensureQueryData(workspaceInvitationsQueries.listCurrent(workspace_id)),
    ]);
  },
  component: WorkspaceUsersPage,
});
